document.addEventListener("DOMContentLoaded", function () {
  // Catch Shopify cart change form submissions (works on most themes)
  document.addEventListener("submit", function (e) {
    if (e.target.closest("form[action*='/cart/change']")) {
      setTimeout(() => window.location.reload(), 1000);
    }
  });

  // Extra safety: catch clicks on +, -, and remove buttons (some themes use JS not forms)
  document.addEventListener("click", function (e) {
    if (
      e.target.closest('[name="plus"], [name="minus"], .cart__qty-button, [data-cart-remove], .cart__remove')
    ) {
      setTimeout(() => window.location.reload(), 1000);
    }
  });
});
